import { render, staticRenderFns } from "./EquipeTabList.vue?vue&type=template&id=44c99f7c&scoped=true"
import script from "./EquipeTabList.vue?vue&type=script&lang=js"
export * from "./EquipeTabList.vue?vue&type=script&lang=js"
import style0 from "./EquipeTabList.vue?vue&type=style&index=0&id=44c99f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c99f7c",
  null
  
)

export default component.exports